import React, { useState, useEffect, createRef } from 'react';
import { MapContainer, Marker, TileLayer, Popup } from 'react-leaflet';
import { faFileAlt, faSearch, faStreetView } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col, Button } from 'reactstrap';
import MarkerClusterGroup from 'react-leaflet-markercluster';
import moment from "moment";

//Components
import MainCard from '../../components/MainCard/MainCard';
import TextField from '../../components/TextField/TextField';
import Loading from '../../components/Loading/Loading';
//Api
import transportador_api from '../../api/transportador_api';
import ramoDeAtividade_api from '../../api/ramoDeAtividade_api';
import modalidadeColeta_api from '../../api/modalidadeColeta_api';
import mapasService_api from '../../api/mapasService_api';
import gerador_api from '../../api/gerador_api';

//Assets
import { iconeRamoAtividade } from '../../assets/Icons/Icons';

//Helpers
import { showMessage } from '../../helpers/message';
import { getSessionCookie } from '../../helpers/cookies';
import mascaras from '../../helpers/mascaras';

//Shared
import FiltroPrefeitura from 'views/Shared/FiltroPrefeitura';
import FichaGeradorContainer from 'views/Cadastros/Geradores/components/FichaGeradorContainer';

//Context
import { useAuth } from '../../context/auth';

//Estado inicial para os campos de filtros
function initialStateFiltros() {
    return {
        transportadorId: 0,
        transportadorId_selected: null,
        modalidadesIds: [],
        modalidadesIds_selected: null,
        ramoAtividadeIds: [],
        ramoAtividadeIds_selected: null,
        prefeituraId: 0,
        cnpj: null,
        endereco: ""
    };
}
export default function PontosColetas() {
    const { setupVariavel } = useAuth();

    //Dados do usuario logado
    const usuario = getSessionCookie();

    //Estado que guarda o id da prefeitura selecionada no select das prefeituras no ambiente privado ou da prefeitura default no ambiente público
    const [prefeitura_Id, setPrefeitura_Id] = useState(null);
    const handlePrefeitura = (value) => {
        //salva o id da prefeitura nos filtros
        setFiltros({
            ...filtros,
            prefeituraId: value
        })

        setPrefeitura_Id(value);
        //Pegando os pontos iniciais de coleta
        carregarPontos(value);
    }
    //Localização inicial do mapa
    const [location, setLocation] = useState([-23.2198396, -45.8915658]);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle de exibição dos filtros
    const [openFiltros, setOpenFiltros] = useState(false);

    //Troca o estado de visualização dos filtros
    const toggleFiltros = () => setOpenFiltros(!openFiltros);

    //Estado da referencia do mapa
    const [map, setMap] = useState(null);

    //Ponto que foi selecionado na listagem lateral
    const [pointSelected, setPointSelected] = useState(null);

    //Estado de controle da visualização de satelite
    const [viewSatelite, setViewSatelite] = useState(() => false);

    //Troca o estado da visão de satelite 
    const toggleViewSatelite = () => setViewSatelite(() => !viewSatelite);

    //Guarda os pontos de coleta que serão listados
    const [pontosDeColeta, setPontosDeColeta] = useState([]);

    //Guarda os transportadores do filtro
    const [transportadores, setTransportadores] = useState([]);

    //Guarda as opções de modalidades de coletas
    const [modalidadesDeColeta, setModalidadesDeColeta] = useState([]);

    //Guarda as opções do filtro de ramos de atividade
    const [ramosDeAtividade, setRamosDeAtividade] = useState([]);

    //Estado de filtros
    const [filtros, setFiltros] = useState(initialStateFiltros());

    //Estado de controle dos dados do gerador
    const [gerador, setGerador] = useState(null);

    //onChange para os campos de multi select
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        })
    }

    //onChange para os multiSelects
    const onChangeMultiSelect = (e, select) => {
        const { name } = select;
        const ids = e.map(op => op.value);
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: ids
        })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    const carregarPontos = (prefeituraId = null) => {
        const _filtros = { ...filtros };
        if (prefeituraId) {
            _filtros.prefeituraId = prefeituraId;
        }
        setLoading(true);
        mapasService_api.PontosDeColeta(_filtros).then(response => {
            response.data = response.data.map(value => {
                value.latitude = value.latitude.replace(",", ".");
                value.longitude = value.longitude.replace(",", ".");
                value.markerRef = createRef()
                value.divRef = createRef()
                return value;
            })
            setPontosDeColeta(response.data);

        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const loadTransportadores = () => {
        setLoading(true);
        //Pegando as opções de transportadores
        transportador_api.GetAll().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.fantasia };
            });
            setTransportadores(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const loadModalidades = () => {
        setLoading(true);
        //Pegando as opções de modalidades de coleta
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao }
            })
            setModalidadesDeColeta(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const loadRamoAtvidade = () => {
        setLoading(true);
        //Pegando as opções de ramos de atividade
        ramoDeAtividade_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            })
            setRamosDeAtividade(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função realizada ao ser clicado em pesquisar e ao iniciar a tela
    useEffect(() => {
        if(setupVariavel?.coordenadaPrefeitura){
            const [latitude, longitude] = setupVariavel?.coordenadaPrefeitura.split(";");
            setLocation([parseFloat(latitude), parseFloat(longitude)])
        }
        loadTransportadores();
        loadModalidades();
        loadRamoAtvidade();
    }, []);

    function handleFichaGerador(gerador) {
        setLoading(true);
        gerador_api.GetItem(gerador?.gerador_Id ? gerador?.gerador_Id : 0)
            .then(response => {
                if (response.data.tbPrefeituras_id) {
                    response.data.tbPrefeituras_id = response.data.tbPrefeituras_id.toString();
                }
                if (response.data.tbSetores_Id) {
                    response.data.tbSetores_Id = response.data.tbSetores_Id.toString();
                }
                if (response.data.tbSegmentos_Id) {
                    response.data.tbSegmentos_Id = response.data.tbSegmentos_Id.toString();
                }
                if (response.data.dataValidade) {
                    response.data.dataValidade = moment(response.data.dataValidade).format("YYYY-MM-DD")
                }

                response.data.localidades = response.data.localidades.map(localidade => {
                    if (localidade.localidadePadrao) {
                        localidade.principal = "Sim";
                    } else {
                        localidade.principal = "Não";
                    }
                    localidade.contratos = localidade.contratos.map(contrato => {
                        Object.keys(contrato).map(key => {
                            if (!contrato[key] === null) {
                                contrato[key] = "";
                            }

                        });
                        contrato.quantidadeContratada = contrato.quantidadeContratada ? contrato.quantidadeContratada.toString().replace(".", ",") : "";
                        return contrato;
                    });

                    return localidade;
                })
                setGerador(response.data);

            })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    if (gerador) {
        return <MainCard
            btnVoltar={() => setGerador(null)}
        >
            <FichaGeradorContainer
                gerador={gerador}
                modulo={usuario.acesso.modulo}
                integracaoCadastros={false}
                visualizarFicha={true}
            />
        </MainCard>
    }

    return (
        <MainCard noCard title={"Pontos de coletas"} btnFiltros={toggleFiltros}>
            <div className={`filtros ${openFiltros ? "" : "close"}`}>
                {loading && <Loading />}

                <Row>
                    <Col md={"12"} lg="4">
                        <TextField
                            name={"modalidadesIds_selected"}
                            value={filtros.modalidadesIds_selected}
                            onChange={onChangeMultiSelect}
                            label="Modalidade de coleta"
                            type={"select"}
                            options={modalidadesDeColeta}
                            multiple
                        />
                    </Col>
                    <Col md={"12"} lg="4">
                        <TextField
                            name={"transportadorId_selected"}
                            value={filtros.transportadorId_selected}
                            onChange={onChangeSelected}
                            label="Transportadores"
                            searchable
                            type={"select"}
                            options={transportadores}
                        />
                    </Col>
                    <Col md={"12"} lg="4">
                        <TextField
                            name={"ramoAtividadeIds_selected"}
                            value={filtros.ramoAtividadeIds_selected}
                            onChange={onChangeMultiSelect}
                            label="Ramo de atividade"
                            type={"select"}
                            options={ramosDeAtividade}
                            multiple
                        />
                    </Col>
                    <Col md="12" lg="4" className='mx-0'>
                        <TextField
                            label={"Gerador (CNPJ)"}
                            name={"cnpj"}
                            type={"text"}
                            onChange={onChange}
                            value={filtros.cnpj}
                            mask={mascaras.cnpjMask}
                            maxLength={18}
                            onBlur={() => setFiltros({
                                ...filtros,
                                ["cnpj"]: mascaras.cnpjMask(filtros.cnpj, true)
                            })}
                        />
                    </Col>
                    <Col md="12" lg="4" className='mx-0'>
                        <TextField
                            label={"Logradouro e Número (separados por vírgula)"}
                            name="endereco"
                            value={filtros.endereco}
                            onChange={onChange}
                        />
                    </Col>
                    <Col md={"12"} lg="2" className='mt-2'>
                        <br />
                        <Button
                            color='info'
                            style={{ color: "#fff" }}
                            className={"w-100"}
                            onClick={() => carregarPontos()}
                        >
                            <FontAwesomeIcon icon={faSearch} className={"me-2"} /> Pesquisar
                        </Button>
                    </Col>
                </Row>
            </div>
            <FiltroPrefeitura handleValue={handlePrefeitura}></FiltroPrefeitura>
            {
                pontosDeColeta.length == 0 &&
                <MainCard>
                    <h5>Nenhum ponto de coleta encontrado para exibição do mapa.</h5>
                </MainCard>
            }
            {pontosDeColeta.length > 0 &&
                <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 rounded-3 overflow-hidden shadow">
                    <Col md="12" lg="5" className=' m-0 p-0 overflow-auto ListagemDePontos d-none d-lg-block' style={{ height: "65vh" }}>
                        {
                            pontosDeColeta.map((value, key) => {
                                return (
                                    <div ref={value.divRef} key={key} className={`${pointSelected && pointSelected.id === value.id ? "active" : ""} rounded-3 p-2 m-2 shadow containerInfoMap`} onClick={() => {
                                        setLocation([parseFloat(value.latitude), parseFloat(value.longitude)]);
                                        if (map) {
                                            map.flyTo([parseFloat(value.latitude), parseFloat(value.longitude)]);
                                        }
                                        setPointSelected(value);
                                        const marker = value.markerRef.current
                                        if (marker) {
                                            marker.openPopup()
                                        }
                                    }}>
                                        <p className='m-1'> <span className="fw-bold">Nome: </span> {value.fantasia}</p>
                                        <p className='m-1'> <span className="fw-bold">Modalidade: </span> {value.modalidadeColeta}</p>
                                        <div className="mt-3 d-flex align-items-center justify-content-center w-100">
                                            <Button style={{ fontSize: "8pt" }} color='primary' onClick={() => handleFichaGerador(value)}>
                                                <FontAwesomeIcon size='1x' icon={faFileAlt} className='mr-2' /> Visualizar Ficha do Gerador
                                            </Button>
                                        </div>
                                    </div>
                                )
                            })
                        }

                    </Col>
                    <Col md="12" lg="7" className=' m-0 p-0'>
                        <MapContainer
                            center={location}
                            zoom={13}
                            scrollWheelZoom={false}
                            ref={setMap}
                            whenCreated={map => setMap(map)}
                            style={{ height: "100%", width: "100%", zIndex: "10" }}
                        >
                            <Button color='light border' className='buttonSatelite' onClick={toggleViewSatelite}><FontAwesomeIcon size='1x' icon={faStreetView} /></Button>

                            <TileLayer
                                url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                                attribution='© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, © <a href="https://carto.com/attribution">CARTO</a>'
                            />
                            {
                                viewSatelite
                                &&
                                <TileLayer
                                    url='https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}'
                                    maxZoom={20}
                                    subdomains={['mt1', 'mt2', 'mt3']}
                                />

                            }
                            <MarkerClusterGroup>
                                {pontosDeColeta.map((value, index) => {

                                    return (
                                        <Marker key={index} position={[value.latitude, value.longitude]} icon={iconeRamoAtividade(require('../../assets/img/icones/' + value.icone))}
                                            eventHandlers={{
                                                click: (e) => {
                                                    setLocation(e.latlng);
                                                    if (map != null) {
                                                        map.flyTo(e.latlng);
                                                    }
                                                    value.divRef.current.scrollIntoView({ behavior: 'smooth', block: "center" });
                                                    setPointSelected(value);
                                                },
                                            }}
                                            ref={value.markerRef}
                                        >
                                            <Popup className='popup-leaflet'> <p className=' text-secondary fw-bold'>Frequência: {value.frequencia.split("\n").map(value => <><br />{value}</>)} </p></Popup>
                                        </Marker>
                                    )
                                })}
                            </MarkerClusterGroup>
                        </MapContainer>
                    </Col>
                </Row>
            }
            {
                pointSelected &&
                <Row className='d-lg-none'>
                    <Col md={"12"} className={"m-0"}>
                        <div className='rounded-3 p-2 mt-4 shadow' style={{ backgroundColor: "#ffffff", color: "#666" }}>
                            <div className='d-flex align-items-center justify-content-end'><p className='d-inline p-2 fw-bold' onClick={() => setPointSelected(null)}>X</p></div>
                            <p> <span className="fw-bold">Nome: </span> {pointSelected.nome}</p>
                            <p> <span className="fw-bold">Modalidade: </span> {pointSelected.modalidade}</p>
                        </div>
                    </Col>
                </Row>
            }
        </MainCard >
    )
}